var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{ fill:currentcolor;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/home-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/home-2_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.04 6.82018L14.28 2.79018C12.71 1.69018 10.3 1.75018 8.79001 2.92018L3.78001 6.83018C2.78001 7.61018 1.99001 9.21018 1.99001 10.4702V17.3702C1.99001 19.9202 4.06001 22.0002 6.61001 22.0002H17.39C19.94 22.0002 22.01 19.9302 22.01 17.3802V10.6002C22.01 9.25018 21.14 7.59018 20.04 6.82018ZM12.75 18.0002C12.75 18.4102 12.41 18.7502 12 18.7502C11.59 18.7502 11.25 18.4102 11.25 18.0002V15.0002C11.25 14.5902 11.59 14.2502 12 14.2502C12.41 14.2502 12.75 14.5902 12.75 15.0002V18.0002Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 32,
    height: 32
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.59067e598965d4615921a5b83f563a8c.svg";
export { ForwardRef as ReactComponent };